import React from 'react';
import Sectors from '../Constants/Sector.json';
import LegacySectors from '../Constants/Sector.legacy.json';
import useCV from '../Provider/TableContext/CVContext';
import useCVSkillAchievement from '../Provider/TableContext/CVSkillAchievementContext';
import useProfile from '../Provider/TableContext/ProfileContext';
import useRole from '../Provider/TableContext/RoleContext';
import useABC from '../Provider/TableContext/ABCContext';
import useQualification from '../Provider/TableContext/QualificationContext';




export function useCVStepConstants({ id }) {
    const { cvs, processCVChanges, uploadFileToCV, loading: cvLoading } = useCV();
    const { profileData, loading: profileLoading } = useProfile();
    const { roles, loading: rolesLoading } = useRole();
    const { abcs, loading: abcLoading } = useABC();
    const { qualifications, loading: qualificationsLoading } = useQualification();
    const { cvskillachievements, processCVSkillAchievementChanges, loading: cvSkillAchievementLoading } = useCVSkillAchievement();
    const [_loading, setLoading] = React.useState(false);
    const loading = React.useMemo(() => 
        _loading 
        || cvLoading
        || rolesLoading
        || abcLoading
        || profileLoading
        || cvSkillAchievementLoading
        || qualificationsLoading,
        [_loading, cvLoading, profileLoading, cvSkillAchievementLoading, qualificationsLoading, rolesLoading, abcLoading]
    );

    const originalCVKSA = React.useMemo(() => {
        if (!id) return [];
        return cvskillachievements.filter(a => a._mcb_cv_value === id).sort((a, b) => (a?.mcb_index || 0) - (b.mcb_index || 0)
        );
    }, [cvskillachievements, id]);


    const cv = React.useMemo(() => {
        if (loading) return null;
        let cv = cvs?.find(cv => cv.mcb_cvid === id);
        if (cv) {
            cv = { ...cv, keySkillsAchievements: originalCVKSA };
        } else {
            cv = {
                mcb_firstname: profileData?.firstname,
                mcb_lastname: profileData?.lastname,
                mcb_email: profileData?.emailaddress1,
                mcb_phone: profileData?.telephone1,
                mcb_profilesummary: profileData?.adx_publicprofilecopy,
                mcb_currentcity: profileData?.address1_city,
                mcb_linkedin: profileData?.mcb_linkedin,
                mcb_sectors: Array.isArray(profileData?.sectors) ? profileData.sectors.map(value => {
                    let sector = Sectors.find(s => s.value === Number(value));
                    if (sector?.label) return sector.label;
                    sector = LegacySectors.find(s => s.value === Number(value));
                    if (sector?.label) return sector.label;
                    return false;
                }).filter(a => a).join(", ") : "",
                mcb_CVABC: Array.isArray(abcs) ? abcs.map(({ mcb_abcid }) => ({ mcb_abcid })) : [],
                mcb_CVQualifications: Array.isArray(qualifications) ? qualifications.map(({ mcb_qualificationid }) => ({ mcb_qualificationid })) : [],
                mcb_CVRoles: Array.isArray(roles) ? roles.map(({ mcb_roleid }) => ({ mcb_roleid })) : []                                                                        
            };
        }
        return {
            ...cv,
            skills: (Array.isArray(cv?.mcb_CVKeySkill) ? cv.mcb_CVKeySkill.map(({ mcb_skillid }) => mcb_skillid) : []),
            cliftonstrengths: cv?.mcb_cliftonstrength?.length ? cv.mcb_cliftonstrength.split(",").filter(a => !isNaN(a)).map(a => Number(a)) : [],
            achievements: (Array.isArray(cv?.mcb_CVABC) ? cv.mcb_CVABC.map(({ mcb_abcid }) => mcb_abcid) : []),
            qualifications: (Array.isArray(cv?.mcb_CVQualifications) ? cv.mcb_CVQualifications.map(({ mcb_qualificationid }) => mcb_qualificationid) : []),
            cvRoles: (Array.isArray(cv?.mcb_CVRoles) ? cv.mcb_CVRoles.map(({ mcb_roleid }) => mcb_roleid) : [])
        };
    }, [cvs, id, profileData, originalCVKSA, abcs, qualifications, roles, loading]);

    return { cv, cvs, processCVChanges, uploadFileToCV, originalCVKSA, processCVSkillAchievementChanges, loading, setLoading };
}